export const sentryIssuesViewSample = {
  'action': 'created',
  'actor': {
    'id': 'sentry',
    'name': 'Sentry',
    'type': 'application'
  },
  'data': {
    'issue': {
      'annotations': [],
      'assignedTo': null,
      'count': '1',
      'culprit': '?(runner)',
      'firstSeen': '2019-08-19T20:58:37.391000Z',
      'hasSeen': false,
      'id': '1170820242',
      'isBookmarked': false,
      'isPublic': false,
      'isSubscribed': false,
      'lastSeen': '2019-08-19T20:58:37.391000Z',
      'level': 'error',
      'logger': null,
      'metadata': {
        'filename': '/runner',
        'type': 'ReferenceError',
        'value': 'blooopy is not defined'
      },
      'numComments': 0,
      'permalink': null,
      'platform': 'javascript',
      'project': {
        'id': '1',
        'name': 'front-end',
        'platform': '',
        'slug': 'front-end'
      },
      'shareId': null,
      'shortId': 'FRONT-END-9',
      'status': 'unresolved',
      'statusDetails': {},
      'subscriptionDetails': null,
      'substatus': 'escalating',
      'title': 'ReferenceError: blooopy is not defined',
      'type': 'error',
      'userCount': 1
    }
  },
  'installation': {
    'uuid': 'a8e5d37a-696c-4c54-adb5-b3f28d64c7de'
  }
}
;

  export const sentryIssuesSample = {
    'data::issue.title': 'ReferenceError: blooopy is not defined',
    'data::issue.id': '1170820242',
    'action': 'created',
    'data::issue.firstSeen': '2019-08-19T20:58:37.391000Z',
    'data::issue::metadata.filename': '/runner',
  };
  


// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/sentry_issues.ts